module.exports = __webpack_public_path__ + "static/media/roundedrect-primary-wide@3x.a997c3c9.png";